const enigmes = {
    enigme1: {
        title: " Sans-Visage de la Garnison",
coords:"3,186,151,370", 
       shape: "rect",
        text: " Par Alindée, si Fer-Gémeaux l’apprend, on va passer un mauvais moment…<br> Il va nous faire nettoyer les latrines pendant un mois.",
    },
    enigme2: {
        title: " Sans-Visage de la Garnison",
 coords:"393,468,587,233",   
     shape: "rect",
        text: "Ne paniquons pas, c’est simple,<br> il suffit de retrouver tous les morceaux.",
    },
    Enigme3: {
        title: "Sans-Visage de la Garnison",
 coords:"1008,762,1229,287,1103,307",   
     shape: "rect",
        text: "Simple ? Un sale plop s’en est emparé,<br> l’a déchiquetée en morceaux et l’a semée aux quatre vents ! <br>Ça va être tout sauf simple !",
    },

};
export default enigmes;